import { b, a } from './chunk-FUQLNXR2.mjs';
import { jsx } from 'react/jsx-runtime';

var n=l=>jsx("svg",b(a({width:"10",height:"8",viewBox:"0 0 10 8",fill:"none",xmlns:"http://www.w3.org/2000/svg"},l),{children:jsx("path",{d:"M5.86603 7.5C5.48113 8.16667 4.51887 8.16667 4.13397 7.5L0.669873 1.5C0.284973 0.833334 0.766099 0 1.5359 0L8.4641 0C9.2339 0 9.71503 0.833333 9.33013 1.5L5.86603 7.5Z",fill:"currentColor"})})),e=n;

export { e as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-LWFN5OD5.mjs.map